export default __webpack_public_path__ + "static/media/menu_5_price_2.242c3f30.svg";